import React, { useState, useEffect } from 'react';
import { Layout, Menu, Avatar, Badge, Dropdown, Space } from 'antd';
import { BellOutlined, UserOutlined, SettingOutlined, LogoutOutlined, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import './AppHeader.css';

const { Header } = Layout;

const AppHeader = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [time, setTime] = useState(new Date());
  const location = useLocation();
  
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  
  const menuItems = [
    { key: '/dashboard', label: <Link to="/dashboard">全景监测驾驶舱</Link> },
    { key: '/indicators', label: <Link to="/indicators">指标监测分析</Link> },
    { key: '/warnings', label: <Link to="/warnings">预警中心</Link> },
    { key: '/services', label: <Link to="/services">企业服务大厅</Link> },
    { key: '/decision-lab', label: <Link to="/decision-lab">决策分析实验室</Link> },
    { key: '/workbench', label: <Link to="/workbench">个人工作台</Link> },
  ];
  
  const userMenuItems = [
    {
      key: 'profile',
      label: '个人中心',
      icon: <UserOutlined />,
    },
    {
      key: 'settings',
      label: '设置',
      icon: <SettingOutlined />,
    },
    {
      key: 'logout',
      label: '退出登录',
      icon: <LogoutOutlined />,
    },
  ];
  
  return (
    <Header className="app-header">
      <div className="header-left">
        <div className="logo-container">
          <img
            src="/logo.png"
            alt="YBBE拔俗网络"
            className="logo"
            onError={(e) => {
              console.error("Logo加载失败: ", e.target.src);
            }}
          />
          <h1 className="company-name">营商环境平台</h1>
        </div>
        {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
          className: 'trigger',
          onClick: () => setCollapsed(!collapsed),
        })}
      </div>
      
      <Menu mode="horizontal" selectedKeys={[location.pathname]} items={menuItems} className="header-menu" />
      
      <div className="header-right">
        <div className="header-time">{time.toLocaleString()}</div>
        <Badge count={5} size="small">
          <BellOutlined className="header-icon" />
        </Badge>
        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <Space className="user-dropdown">
            <Avatar icon={<UserOutlined />} />
            <span className="username">管理员</span>
          </Space>
        </Dropdown>
      </div>
    </Header>
  );
};

export default AppHeader; 